<template>
  <div class="top-section">
    <div class="top-section__container pt-40 pt-48--l flx">
      <div class="top-section__info-block mb-32 mb-0--l">
        <h1
          class="top-section__title txt--color-04 txt--26px txt--52px--l txt--height-34px txt--height-64px--l mb-6 mb-20--l"
        >
          {{ $t('listing.title') }}
        </h1>
        <p
          class="top-section__description txt--color-03 txt--14px txt--22px--l txt--height-18px txt--height-30px--l mb-0"
        >
          {{ $t('listing.listingDescription') }}
        </p>
      </div>
      <div class="top-section__links flx">
        <!-- <exc-button
          :size="isMobile ? 's' : 'm'"
          :full-width="isMobile"
          class="top-section__btn"
          href="https://t.me/c-patex_listing"
          target="_blank"
        >
          <span class="txt--center">
            {{ $t('listing.askOnTelegram') }}
          </span>
        </exc-button> -->
        <exc-button
          :size="isMobile ? 's' : 'm'"
          :full-width="isMobile"
          color="dark"
          outline
          class="top-section__btn"
          href="mailto:listing@c-patex.com"
          target="_blank"
        >
          listing@c-patex.com
        </exc-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'

export default {
  name: 'TopSection',
  components: {
    ExcButton,
  },
  computed: {
    isMobile () {
      return this.$mq?.resize && this.$mq?.below(768)
    },
  },
}
</script>

<style lang="scss" scoped>
.top-section {
  &__container {
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;

    @include bp(l) {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  &__info-block {
    @include bp(l) {
      align-self: flex-start;
    }
  }

  &__description {
    @include bp(l) {
      max-width: toRem(628px);
    }
  }

  &__links {
    flex-direction: column;
    align-items: flex-start;
    gap: toRem(8px);
    width: 100%;

    @include bp(l) {
      width: auto;
      flex-direction: row;
      align-items: center;
    }
  }

  &__btn {
    white-space: nowrap;
  }
}
</style>
